import { useMemo, useState } from 'react'

import { getPreciseTimeLeft } from '_utils/function'
import {
  getIsShowAllEventOping,
  getSortTypeEvent,
  setIsShowAllEventOping,
  setSortTypeEvent,
} from '_utils/localData'

const CLOSING_SOON_DAYS_THRESHOLD = 2

export const SORT_OPTIONS = [
  { value: 'default', label: 'Sort By' },
  { value: 'close_asc', label: 'Close date (Asc)' },
  { value: 'close_desc', label: 'Close date (Desc)' },
  { value: 'title_asc', label: 'Title (A-Z)' },
  { value: 'title_desc', label: 'Title (Z-A)' },
]

export const isEventClosed = (event) => getPreciseTimeLeft(event.pickupTimestamp).days <= 0

const isEventClosingSoon = (event) => {
  const daysToClose = getPreciseTimeLeft(event.closingTimestamp).days
  return !isEventClosed(event) && daysToClose <= CLOSING_SOON_DAYS_THRESHOLD
}

const matchesFilter = (event, filter) => {
  switch (filter) {
    case 'active':
      return !isEventClosed(event)
    case 'closing':
      return isEventClosingSoon(event)
    case 'expired':
      return isEventClosed(event)
    default:
      return true
  }
}

const sortEvents = (events, sortOption) => {
  const sorted = [...events]
  switch (sortOption) {
    case 'close_asc':
      return sorted.sort((a, b) => a.closingTimestamp - b.closingTimestamp)
    case 'close_desc':
      return sorted.sort((a, b) => b.closingTimestamp - a.closingTimestamp)
    case 'title_asc':
      return sorted.sort((a, b) => a.title.localeCompare(b.title))
    case 'title_desc':
      return sorted.sort((a, b) => b.title.localeCompare(a.title))
    default:
      return sorted
  }
}

const getInitialFilter = () => (getIsShowAllEventOping() === false ? 'all' : 'active')

const useToolBar = (events = []) => {
  const [view, setView] = useState('tile')
  const [searchValue, setSearchValue] = useState('')
  const [sortOption, setSortOption] = useState(getSortTypeEvent() || 'default')
  const [filter, setFilter] = useState(getInitialFilter)

  const handleFilterChange = (value) => {
    setFilter(value)
    setIsShowAllEventOping(value !== 'all')
  }

  const handleSortChange = (value) => {
    setSortOption(value)
    setSortTypeEvent(value)
  }

  const visibleEvents = useMemo(() => {
    const safeEvents = events || []
    const searched = searchValue
      ? safeEvents.filter((event) => (
        event?.title?.toLowerCase().includes(searchValue.toLowerCase())
      ))
      : safeEvents

    const filtered = searched.filter((event) => matchesFilter(event, filter))
    return sortEvents(filtered, sortOption)
  }, [events, searchValue, filter, sortOption])

  const toolbarProps = {
    searchValue,
    onSearchChange: setSearchValue,
    filter,
    onFilterChange: handleFilterChange,
    sortOption,
    sortOptions: SORT_OPTIONS,
    onSortChange: handleSortChange,
    view,
    onViewChange: setView,
  }

  return {
    view,
    setView,
    filter,
    searchValue,
    sortOption,
    visibleEvents,
    toolbarProps,
    isEventClosed,
  }
}

export default useToolBar
